module.exports = __webpack_public_path__ + "img/Andrew-Stephen-Secretary-Treasurer-2022-english.d01f97fd.jpg";